import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Reveal from '@/components/base/Reveal';

const quickLinks = [
  { key: 'nav.story', to: '/zgodba' },
  { key: 'nav.menu', to: '/jedilnik' },
  { key: 'nav.wines', to: '/vina' },
  { key: 'nav.visit', to: '/obisk' },
  { key: 'nav.gift', to: '/darilni-boni' },
];

export default function HomeHero() {
  const { t } = useTranslation();
  const lead = t('home.hero.lead');

  return (
    <section className="relative flex min-h-screen w-full items-center overflow-hidden bg-background-50">
      {/* Full-screen fireplace backdrop spanning the entire entry page */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/9155b4900a2a6988420e02fcbe0779ed.png"
          alt="Krušna peč s plamenom v jedilnici Črne Kuhne"
          title="Krušna peč v Črni Kuhni – ogenj kot izhodišče kuhinje"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-background-50/45" />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/75 via-background-50/25 to-background-50/85" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-6xl px-4 pb-24 pt-28 md:px-8 md:pb-28 md:pt-32">
        <Reveal className="flex w-full flex-col items-center text-center">
          <h1 className="flex w-full flex-col items-center">
            <span className="sr-only">{t('home.hero.title')}</span>
            <img
              src="https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/3908b3bb29ee6048b30a3f1afa5e734f.png"
              alt="Črna Kuhna Restaurant"
              title="Črna Kuhna Restaurant"
              className="h-auto w-[min(190px,52%)] sm:w-[min(240px,44%)] md:w-[320px]"
            />
          </h1>

          <span className="mt-8 font-label text-[11px] uppercase tracking-[0.3em] text-primary-300">
            {t('home.hero.eyebrow')}
          </span>
          <p className="mt-5 font-heading text-xl italic text-accent-300 md:text-2xl">
            {t('home.hero.tagline')}
          </p>
          {lead ? (
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-foreground-700/90 md:text-lg">
              {lead}
            </p>
          ) : null}

          <div className="mt-9 flex w-full flex-col items-center gap-3 sm:w-auto sm:flex-row">
            <Link
              to="/rezervacije"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 font-label text-sm font-medium tracking-wide text-foreground-950 transition-colors duration-200 hover:bg-primary-400 cursor-pointer sm:w-auto md:text-base"
            >
              <i className="ri-calendar-check-line text-base" />
              {t('home.hero.ctaReserve')}
            </Link>
            <Link
              to="/jedilnik"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-700/40 px-6 py-3.5 font-label text-sm font-medium tracking-wide text-foreground-950 transition-colors duration-200 hover:bg-foreground-950/10 cursor-pointer sm:w-auto md:text-base"
            >
              {t('home.hero.ctaMenu')}
            </Link>
          </div>

          <div className="mt-10 w-full">
            <p className="font-label text-[11px] uppercase tracking-[0.22em] text-primary-300">
              {t('home.hero.linksNote')}
              <span className="mx-2 text-primary-300/60">·</span>
              <a
                href={`tel:${t('contact.phoneHref')}`}
                className="inline-flex items-center gap-1.5 whitespace-nowrap font-medium tracking-[0.18em] text-primary-300 underline decoration-primary-300/40 underline-offset-4 transition-colors duration-200 hover:text-primary-200 hover:decoration-primary-200 cursor-pointer"
              >
                <i className="ri-phone-line text-sm" />
                {t('contact.phone')}
              </a>
            </p>
            <div className="mt-2 flex flex-col items-center" aria-hidden="true">
              <span className="block h-6 w-px bg-primary-300/60" />
              <i className="ri-arrow-down-line -mt-1 text-lg text-primary-300/80" />
            </div>
            <div className="mt-1 w-full rounded-lg border border-primary-400/30 bg-background-100/60 px-4 py-5 md:px-6 md:py-6">
              <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
                {quickLinks.map((item) => (
                  <Link
                    key={item.to}
                    to={item.to}
                    className="group inline-flex items-center gap-1.5 whitespace-nowrap border-b border-foreground-700/30 pb-0.5 font-label text-sm tracking-wide text-foreground-950 transition-colors duration-200 hover:border-accent-300 hover:text-accent-300 cursor-pointer"
                  >
                    {t(item.key)}
                    <i className="ri-arrow-right-up-line text-xs text-foreground-600/70 transition-colors duration-200 group-hover:text-accent-300" />
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}